<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab href="#Member" ripple>{{ $t('Member') }}</v-tab>
      <v-tab href="#Imei" ripple>{{ $t('IMEI') }}</v-tab>
      <v-tab href="#Campaign" ripple>{{ $t('Campaign') }}</v-tab>
    </v-tabs>
    <div :key="currentView">
      <component :is="currentView"></component>
    </div>
  </div>
</template>

<script>
import Member from './member/main.vue'
import Imei from './imei/main.vue'
import Campaign from './campaign/main.vue'
// import WorkStyles from './WorkStyles'
export default {
  data() {
    return {
      currentView: 'Member'
    }
  },
  components: {
    Member,
    Imei,
    Campaign

    // Applicants,
    // WorkStyles
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/main.vue